import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { autom2plataformaTranslationRef } from '@internal/plugin-autom2plataforma';

export const autom2plataformaTranslations = createTranslationResource({
  ref: autom2plataformaTranslationRef,
  translations: {
    en: () => import('./autom2plataforma-en'),
    es: () => import('./autom2plataforma-es'),
  },
});
